import { Injectable } from '@angular/core';
import { SharedAction } from './shared-action.interface';

@Injectable()
export class SharedActions {

  static REVERT = '[Shared Action] Revert';

  revert (revertKeys: Array<string>): SharedAction {
    return {
      type:    SharedActions.REVERT,
      payload: {revertKeys}
    };
  }

}
